import React from "react";
import FormPrintRaportyWakel from "./FormPrintRaportyWakel";
import rahel from "./../../../img/rahel1.jpg";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const InputRaportyWakel = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            RW_from,
            RW_to,
            RW_zh_barez,
            RW_nawibrez,
            RW_rasedyKotaye$,
            RW_koyfroshtndolar,
            RW_koyfroshtndianr,
            RW_rasedyKotayeID,
            Rw_koyparaydrawba$,
            Rw_koyparaydrawbaID,
            RW_koyGaranawadolar,
            RW_koyGaranawadianr,
            RW_koyDashkanDolar,
            RW_koyDashkanDinar
          } = value;
          return (
            <>
              <img src={rahel} alt="rahel" />
              <div className="row mb2">
                <div className="col-4 text-right form-inline "></div>
                <div className="col-4 text-right form-inline ">
                  <div className="form-group ">
                    <label className="font-weight-bold f3 ml5">
                      ڕاپۆرتی وەکیل
                    </label>
                  </div>
                </div>
                <div className="col-4 text-right form-inline"></div>
              </div>

              <div
                className="row text-dark font-weight-bold f3 mx-4"
                style={{ border: "2px solid black" }}
              >
                <div className="col-3 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5 ">{RW_to}</h5>
                    <label className="font-weight-bold mb-2 ml1">
                      : بۆ بەرواری
                    </label>
                  </div>
                </div>

                <div className="col-3 text-right  form-inline ">
                  <div className="form-group">
                    <h5 className="font-weight-bold mt1 ml5  ">{RW_from}</h5>
                    <label className="font-weight-bold mb-2  ml1">
                      : لە بەرواری{" "}
                    </label>
                  </div>
                </div>
                {/* <div className="col-1 text-right  form-inline"></div> */}

                <div className="col-3 text-right  form-inline ">
                  <div className="form-group ">
                    <h6 className=" mt2 ml5  fk">({RW_nawibrez})</h6>
                    <label className=" f3 fk ">:بەڕێز</label>
                  </div>
                </div>

                <div className="col-3 text-right form-inline">
                  <div className="form-group ml6">
                    <h6 className="mt2  fk">{RW_zh_barez}</h6>
                    <label className="font-weight-bold f3 ml2 fk">:ژمارە</label>
                  </div>
                </div>
              </div>

              <div className="mt4"></div>
              <FormPrintRaportyWakel />

              {/* Summary Section - Simple Print Design */}
              <div className="mt-4" style={{ border: "2px solid black" }}>
                <h4 className="text-center font-weight-bold py-2 m-0" style={{ borderBottom: "2px solid black", backgroundColor: "white" }}>
                  کورتەی ڕاپۆرت
                </h4>

                {/* Dollar Row */}
                <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th className="text-center font-weight-bold" colSpan="4">بە دۆلار ($)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RW_rasedyKotaye$).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>قەرزی کۆتایی</td>

                      <td className="text-center" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RW_koyfroshtndolar).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>کۆی فرۆشتن</td>

                    </tr>
                    <tr>
                      <td className="text-center">
                        <NumberFormat
                          value={Number(Rw_koyparaydrawba$).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold">پارەی دراو</td>

                      <td className="text-center">
                        <NumberFormat
                          value={Number(RW_koyGaranawadolar).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold">گەڕانەوەی کاڵا</td>

                    </tr>
                    <tr>
                      <td className="text-center">
                        <NumberFormat
                          value={Number(RW_koyDashkanDolar).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"$"}
                        />
                      </td>
                      <td className="text-right font-weight-bold">کۆی داشکاندن</td>
                      <td className="text-right font-weight-bold"></td>
                      <td className="text-center"></td>
                    </tr>
                  </tbody>
                </table>

                {/* Dinar Row */}
                <table className="table table-bordered mb-0" style={{ fontSize: "14px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f0f0f0" }}>
                      <th className="text-center font-weight-bold" colSpan="4">بە دینار (IQD)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RW_rasedyKotayeID).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>قەرزی کۆتایی</td>
                      <td className="text-center" style={{ width: "25%" }}>
                        <NumberFormat
                          value={Number(RW_koyfroshtndianr).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold" style={{ width: "25%" }}>کۆی فرۆشتن</td>

                    </tr>
                    <tr>
                      <td className="text-center">
                        <NumberFormat
                          value={Number(Rw_koyparaydrawbaID).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold">پارەی دراو</td>
                      <td className="text-center">
                        <NumberFormat
                          value={Number(RW_koyGaranawadianr).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold">گەڕانەوەی کاڵا</td>

                    </tr>
                    <tr>
                      <td className="text-center">
                        <NumberFormat
                          value={Number(RW_koyDashkanDinar).toFixed(2)}
                          displayType={"text"}
                          thousandSeparator={true}
                          prefix={"IQD "}
                        />
                      </td>
                      <td className="text-right font-weight-bold">کۆی داشکاندن</td>

                      <td className="text-right font-weight-bold"></td>
                      <td className="text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default InputRaportyWakel;
